module.exports = __webpack_public_path__ + "data/locale-ua.json";


/*****************
 ** WEBPACK FOOTER
 ** ./app/data/locale-ua.json
 ** module id = 542
 ** module chunks = 1
 **/